const $ = require('jquery');
const _ = require("underscore");
import run from '../../utilities/run';
import render from "../../utilities/render";
import { setElementsFromScope } from '../../utilities/selectorHelpers';
import { createPreventDefault } from '../../utilities/general';
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

require("./discountDetails.less");

let els = {};
const elsMap = {
    detailsdiscountsName: "#dtls-discount-name",
    editdiscountsBtn: ".dtls-edit-btn",
    duplicateDiscountsBtn: ".dtls-duplicate-btn"
}
const elsModal = {};
const elsModalMap = {};
const targetSelector = "#discounts-details";

run(targetSelector, (mainEl) => {
    let targetObject = "";
    let deActivatediscountsModal = null;
    const discountsDetailsJson =JSON.stringify( mainEl.data("discounts-details-json"));
    const activatediscountsBtn = mainEl.find(".activate-discounts");
    const deactivatediscountsBtn = mainEl.find(".deactivate-discounts");
    const changediscountsStatusUrl = mainEl.data("change-status-url");
    const pageReloadUrl = mainEl.data("detail-page-reload-url");
    const editdiscountsUrl = mainEl.data("edit-discounts-url");
    const portletNamespace = mainEl.data("portlet-namespace");
    let  discountValuesdiv = mainEl.find("#detailspage-values-div");
  
    
    function init() {
        setElementsInModals();
        setElements();
        bindElements();
        loadDataOnUI();
    }

    function setElements() {
        setElementsFromScope(els, elsMap, mainEl);
    }

    function setElementsInModals() {
        const body = $('body');
        setElementsFromScope(elsModal, elsModalMap, body);
    }

    function bindElements() {
        
        deactivatediscountsBtn.on("click", function(e){
            e.preventDefault();
            deActivatediscountsModal = new SubmitModalFlow({
            confirmModalTitle: 'Deactivate discounts',
            confirmModalBody: `<div class="q-pad-all-xl">Once deactivated, this discount will no longer be available for selected merchants. This discount can be reactivated at any time.</div>`,
            confirmModalBtnText: 'Deactivate discounts',
            modalDialogClass: "q-modal-dialog-500",
            onConfirmClick: function(){
                deActivatediscountsModal.showLoadingModal();
                handlediscountsActivateDeactivate({url: changediscountsStatusUrl, input: 'N' , success:deactivediscountsSuccess, error: deactivediscountsError});
            }
            });
            deActivatediscountsModal.init();
            deActivatediscountsModal.showConfirmModal();
        });

        activatediscountsBtn.on("click", function(e){
            e.preventDefault();
            deActivatediscountsModal = new SubmitModalFlow({
            confirmModalTitle: 'Activate discounts',
            confirmModalBody: `<div class="q-pad-all-xl">Once activated, this discount will be available for selected merchants. This discount can be deactivated at any time.</div>`,
            confirmModalBtnText: 'Activate discounts',
            modalDialogClass: "q-modal-dialog-500",
            onConfirmClick: function(){
                deActivatediscountsModal.showLoadingModal();
                handlediscountsActivateDeactivate({url: changediscountsStatusUrl, input: 'Y' , success:deactivediscountsSuccess, error: deactivediscountsError});
            }
            });
            deActivatediscountsModal.init();
            deActivatediscountsModal.showConfirmModal();
        });
       
        els.editdiscountsBtn.click(createPreventDefault(editDiscounts));

        els.duplicateDiscountsBtn.click(createPreventDefault(duplicateDiscounts));
        

        $('body').on('click', '.discount-section-collapse-expand-btn', function (e) {
            var target = this.getAttribute('data-q-expander-target');
            $('div' + target).find('i.fa-angle-up').click();
            if ($(this).hasClass('active')) {
            $('div' + target).find('i.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
            } else {
            $('div' + target).find('i.fa-angle-down').removeClass('fa-angle-down').addClass('fa-angle-up');
            }

            $(this).toggleClass("active");

        }); 
        
    }

    function loadDataOnUI(){
        let serviceValues = [];
        let divid;
        getDiscountValuesSectionHtml();
        $("div[id^='US-']").each(function(){
            divid= "#"+this.id;            
        });

        $("div[id^='CA-']").each(function(){
            divid = "#" + this.id;       
        });

        $("div[id^='OTH-']").each(function(){
            divid = "#" + this.id;     
        });

    }

    function loadServiceValues(serviceValues){
        _.each(serviceValues, (el)=>{
           const id= "#"+el.dmdShipmentMethodId;
           $(id).text(el.dmddiscountsValue);
          });
    }

    function deactivediscountsSuccess(data){    
        if(data.responseStatus === "Success"){
			const detailUrlFullURL = pageReloadUrl;
			deActivatediscountsModal.showSuccessModal();
			setTimeout(function() {
			 location.href = detailUrlFullURL;
			},SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
		}else{
			deActivatediscountsModal.showFailureModal();
		}
    }
    function editDiscounts() {
        window.location.href = editdiscountsUrl+'&'+ portletNamespace+ 'discountsId='+ JSON.parse(discountsDetailsJson).discountInfo.rtdId +'&'+portletNamespace +'flow=edit';
    };

    function duplicateDiscounts() {
        window.location.href = editdiscountsUrl+'&'+ portletNamespace+ 'discountsId='+ JSON.parse(discountsDetailsJson).discountInfo.rtdId +'&'+portletNamespace +'flow=duplicate';
    };
    
    function handlediscountsActivateDeactivate({url, input, success, error}){    
		$.ajax({
			url: url,
			data:{"discountsStatus" : input},
			dataType:"JSON",
			type: 'POST',
			success: success,
			error: error
    });    
  }

  function deactivediscountsError(){
    deActivatediscountsModal.hideAllModals();
  }

  
  const discountInfoDisplay = function(discountValue, expandableTarget,btnExpandableTarget,countryCode) {
    const init = render(
      require("./html/discountInfoDisplay.html"),
      {
        discountValue: discountValue,
        expandableTarget: expandableTarget,
        btnExpandableTarget:btnExpandableTarget,
        code: countryCode
      }
    )
    return init;
  };

  const valuesHtml  = function(){
    const valuesContent = render(
        require("./html/discountValues.html"), {
          fedExSmartPost: discountInfoDisplay("FedEx Smart Post", "fedEx-smart-post-expand","toggler-target-united-states","US"),
          fedExSmartPostLightWeight: discountInfoDisplay("FedEx Smart Post Light Weight", "fedEx-smart-post-light-weight-expand","toggler-target-united-states","US"),
          fedexHomeDelivery: discountInfoDisplay("Fedex Home Delivery", "fedex-home-delivery-expand","toggler-target-united-states","US"),
          fedExGround: discountInfoDisplay("FedEx Ground", "fedEx-ground-expand","toggler-target-united-states","US"),
          fedExExpressSaver: discountInfoDisplay("FedEx Express Saver", "fedEx-express-saver-expand","toggler-target-united-states","US"),
          fedEx2Day: discountInfoDisplay("FedEx 2 Day", "fedEx-2-day-expand","toggler-target-united-states","US"),
          fedExPriorityOvernight: discountInfoDisplay("FedEx Priority Overnight", "fedEx-priority-overnight-expand","toggler-target-united-states","US"),
          fedExStandardOvernight: discountInfoDisplay("FedEx Standard Overnight", "fedEx-standard-overnight-expand","toggler-target-united-states","US"),
          amazonSellerFulfilledPrime: discountInfoDisplay("Amazon Seller Fulfilled Prime", "amazon-seller-fulfilled-prime-expand","toggler-target-united-states","US"),
          USPS: discountInfoDisplay("USPS", "USPS-expand","toggler-target-united-states","US"),
          fedExInternationalPriority: discountInfoDisplay("FedEx International Priority", "fedEx-international-priority-expand","toggler-target-canada","CA"),
          fedExInternationalGround: discountInfoDisplay("FedEx International Ground", "fedEx-international-ground-expand","toggler-target-canada","CA"),
          fedexInternationalEconomy: discountInfoDisplay("Fedex International Economy", "fedex-international-economy-expand","toggler-target-canada","CA"),
          fedExInternationalPriorityOutSide: discountInfoDisplay("FedEx International Priority", "fedEx-international-priority-outside-expand","toggler-target-outside","OT"),
          fedexInternationalEconomyOutSide: discountInfoDisplay("Fedex International Economy", "fedex-international-economy-outside-expand","toggler-target-outside","OT")
      })
      return valuesContent
  };
  
  function getDiscountValuesSectionHtml(){
      discountValuesdiv.append(valuesHtml);
  }

   

  init();
  
}); 


// WEBPACK FOOTER //
// ./src/pages/discounts/discountsDetails.js